import constants from '../constants/index';

const ScheduleViewerActions = {
	
	selectViewerCell: function(id, scheduledMeetingId, selected) {
		return {
			type: constants.SELECT_VIEWER_CELL,
			payload: {
				id: id,
				scheduledMeetingId: scheduledMeetingId,
				selected: selected
			}
		};
	},

	selectViewerColumn: function(index, name, value, selected) {
		return {
			type: constants.SELECT_VIEWER_COLUMN,
			payload: {
				index: index,
				name: name,
				value: value,
				selected: selected
			}
		};
	},

	selectViewerSubColumn: function(index, name, value, selected) {
		return {
			type: constants.SELECT_VIEWER_SUBCOLUMN,
			payload: {
				index: index,
				name: name,
				value: value,
				selected: selected
			}
		};
	},

	hideViewerColumn: function(index, name, value) {
		return {
			type: constants.HIDE_VIEWER_COLUMN,
			payload: {
				index: index,
				name: name,
				value: value
			}
		};
	},

	unHideViewerColumns: function() {
		return {
			type: constants.UNHIDE_VIEWER_COLUMNS,
			payload: {}
		};
	}
};

export default ScheduleViewerActions;


/** WEBPACK FOOTER **
 ** ./src/js/actions/schedule_viewer_actions.js
 **/